if (!window.Eurus.loadedScript.has('collection-list-product-availability.js')) {
  window.Eurus.loadedScript.add('collection-list-product-availability.js');

  document.addEventListener('alpine:init', () => {
    Alpine.data('xCollectionListProductAvailability', (productId, productUrl, variantId, initialAvailable) => ({
      variantAvailable: initialAvailable,
      init() {
        document.addEventListener(`eurus:product-card:clear:${productId}`, () => {
          this.refreshAvailability();
        });
        this.$watch('errorMessage', (isError) => {
          if (isError) this.variantAvailable = false;
        });
      },
      async refreshAvailability() {
        if (!this.variantAvailable) return;

        try {
          const response = await fetch(`${productUrl}.js?t=${Date.now()}`, { cache: 'no-store' });
          if (!response.ok) return;

          const product = await response.json();
          const variant = product.variants.find((v) => v.id === variantId);
          if (variant && !variant.available) {
            this.variantAvailable = false;
          }
        } catch (error) {
          console.error(error);
        }
      }
    }));
  });
}
